import React, { useEffect } from 'react';
import { Link, Navigate, useLocation, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import MarkdownDoc from '../content/MarkdownDoc';
import { getDocBySlug } from '../content/docsUtils';
import './Marketing.css';

function DocsPage() {
  const { slug } = useParams();
  const location = useLocation();
  const { user, loading } = useAuth();
  const doc = getDocBySlug(slug);

  useEffect(() => {
    if (doc) {
      document.title = `${doc.title} — Racontera Docs`;
    } else {
      document.title = 'Page not found — Racontera Docs';
    }
  }, [doc]);

  if (loading) {
    return <div className="auth-loading-screen">Loading…</div>;
  }

  if (!doc) {
    return (
      <div className="doc-not-found">
        <h1>Page not found</h1>
        <p>
          <Link to="/docs" className="doc-back">
            Back to documentation
          </Link>
        </p>
      </div>
    );
  }

  if (doc.access === 'auth' && !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <article className="doc-page">
      <Link to="/docs" className="doc-back">
        ← Back to documentation
      </Link>
      <h1>{doc.title}</h1>
      {doc.excerpt && <p className="doc-excerpt">{doc.excerpt}</p>}
      <MarkdownDoc body={doc.body} />
    </article>
  );
}

export default DocsPage;
